module.exports = __webpack_public_path__ + "img/bubble-thumbsup.397737d7.svg";